export default __webpack_public_path__ + "static/media/alternative-investment-strategies.ba6b2026.svg";